export default __webpack_public_path__ + "assets/images/da41e19e4b58806a27c463042ac311da.jpg";